import { createActions } from 'redux-actions';

import { ENDPOINTS_MESSAGES } from '../../config/';
import { NotificationsDataProps } from '../../reducers/DashboardReducer/NotificationsReducer/NotificationsReducer.types';
import { defaultErrorMessage, globalFetch, isAction } from '../../shared/helpers/fetch-helper';
import { logErrorService } from '../../shared/services';

export const { dashboardNotificationsResponse, dashboardNotificationsRequest, dashboardNotificationsResponseFailure } = createActions(
  {
    DASHBOARD_NOTIFICATIONS_RESPONSE: (data: NotificationsDataProps) => ({ data }),
  },
  'DASHBOARD_NOTIFICATIONS_REQUEST',
  'DASHBOARD_NOTIFICATIONS_RESPONSE_FAILURE'
);

export function getLastNotifications(limit: number = 5) {
  return async (dispatch: any, getState: any): Promise<object> => {
    const state = getState();

    if (state.getIn(['dashboard', 'notifications', 'isfetching']) === true) {
      return dispatch(dashboardNotificationsRequest());
    }

    dispatch(dashboardNotificationsRequest());

    return globalFetch(
      `${ENDPOINTS_MESSAGES.messages}/self/messages?order=-dateCreated&limit=${limit}&type=NOTIFICATION`,
      {
        method: 'GET',
        credentials: 'include',
      },
      dispatch,
      () => dispatch(dashboardNotificationsResponseFailure())
    )
      .then(async (json: any): Promise<object> => {
        if (isAction(json, 'DASHBOARD_NOTIFICATIONS_RESPONSE_FAILURE')) {
          return json;
        } else {
          return dispatch(dashboardNotificationsResponse(json));
        }
      })
      .catch((err: any) => {
        logErrorService(err, err);
        defaultErrorMessage(dispatch);

        return dispatch(dashboardNotificationsResponseFailure());
      });
  };
}
